import * as z from "zod/v4";

export const setRefundidIntegration = {
  name: "setRefundidIntegration" as const,
  input: z.object({ apiKey: z.string(), shopId: z.string() }),
  output: z.object({}),
};
